<template>
	<div>
		<div class="classify flex">
			<div class="title">Categories:</div>
			<div class="list">
				<div class="item" 
				@click="switchClassify(index)"
				:class="index == classifyActive ? 'active' : ''"
				v-for="(item,index) in classify" :key="index"
				>{{item.name}}</div>
				<!-- <div class="item btn">展开</div> -->
			</div>
		</div>
		<div class="recommend">
			<div class="list">
				<div class="item" v-for="(item,index) in productList" :key="index" @click="toDetail(item.id)">
					<div class="picture">
						<img :src="imgBaseUrl+item.image" alt="">
					</div>
					<div class="name line_two">{{item.name}}</div>
					<div class="price">£{{item.goods_price}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				classify:[1,2,3,4,5,6,7,8,8,6],
				classifyActive:0,
				classifyId:'',
				productList:[],
				
			}
		},
		created(){
			this.classifyActive = this.$route.query.index;
			this.getClassify();
			this.getList()
		},
		methods:{
			getClassify(){
				this.$api.post('goods/getCategory',{},res=>{
					if(res.code == 1){
						
						this.classify = res.data;
					}
				})
			},
			switchClassify(index){
				this.classifyActive = index;
				this.getList()
			},
			getList(){
				var params = {
					category_id:this.classify[this.classifyActive].id,
					page:this.page
				}
				this.$api.post('goods/getGoodsList',params,res=>{
					if(res.code == 1){
						if(this.page == 1){
							this.productList = res.data.data
						}else{
							this.productList = this.productList.concat(res.data.data)
						}
						this.total = res.data.last_page;
					}
				})
			},
			toDetail(id){
				this.$router.push({path:'/home/mall/detail',query:{id:id}})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.classify{
		width: 1200px;
		margin: 0 auto;
		padding: 70px 0 60px 0;
		border-bottom: 1px solid #5C707A;
		.title{
			font-size: 22px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			flex-shrink: 0;
			line-height: 58px;
		}
		.list{
			display: flex;
			flex-wrap: wrap;
			.item{
				width: 100px;
				height: 58px;
				margin-left: 36px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				text-align: center;
				line-height: 58px;
				cursor: pointer;
				&.active{
					
					background: #5C707A;
					border-radius: 29px;
					
				}
			}
			.btn{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
			}
		}
	}
	.recommend{
		width: 100%;
		padding-top: 28px;
		.title{
			font-size: 40px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			text-align: center;
			margin-bottom: 50px;
		}
		.list{
			width: 1200px;
			margin: 0 auto;
			display: flex;
			flex-wrap: wrap;
			
			.item{
				width: 220px;
				height: 300px;
				background: #F7F2EB;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 10px;
				padding: 10px;
				margin-right: 25px;
				margin-bottom: 20px;
				cursor: pointer;
				&:nth-child(5n+0){
					margin-right: 0;
				}
				
				.picture{
					width: 100%;
					height: 180px;
					overflow: hidden;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.name{
					margin-top: 10px;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #5C707A;
					line-height: 24px;
				}
				.price{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #BF5F49;
					line-height: 30px;
				}
			}
		}
	}
</style>